import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel'
import EirButton from '../eir-button/EirButton';
import { css } from 'emotion';
import { isMobile, isMobileOnly, isLandscape } from "react-device-detect";
import CountdownTimer from '../countdown-timer/CountdownTimer';
function EirFullWidthCarousel(props) {
  const [elementIsClicked, setElementIsClicked] = useState(false);
  let isLandscapeMode = false;
  const ipadPortrait = (window.innerWidth >= 768 && window.innerWidth <= 1024) ? true : false;
  let higherModelIphone = false;
  let loopForCarouselMobile;
  let menuElement = document.querySelector(".navbar-expand-md");
  let menuElementBottom = (menuElement != null) ? menuElement.getBoundingClientRect().bottom : window.innerHeight;
  ((window.innerWidth == 414 && window.innerHeight == 719)) ? higherModelIphone = true : higherModelIphone = false;

  const renderContent = (content) => {
    return { __html: content };
  }
  const [activeSlide, setActiveSlide] = useState(0);
  const [higherEndIphone, setHigherEndIphone] = useState(false)
  const handleSelect = (selectedIndex, e) => {
    setActiveSlide(selectedIndex);
  };
  (!window.matchMedia("(orientation:portrait)").matches) ? isLandscapeMode = true : isLandscapeMode = false;
  // const [carouselProps, setDtSpecs] = useState((!isMobileOnly) ? props.carosuselSpecs.desktop : props.carosuselSpecs.desktop);
  const [carouselProps, setDtSpecs] = useState((!isMobileOnly || isLandscapeMode) ? props.carosuselSpecs.desktop : props.carosuselSpecs.mobile);
  const [arrowControl, setArrowControl] = useState(true);
  const [dotIndicator, setDotIndicator] = useState(true);
  // const [loopingTimer, setLoopingTimer] = useState((!isMobileOnly) ? props.carosuselSpecs.DTLoopInterval : props.carosuselSpecs.MobileLoopInterval);
  const [loopingTimer, setLoopingTimer] = useState((!isMobileOnly) ? props.carosuselSpecs.DTLoopInterval : props.carosuselSpecs.MobileLoopInterval);
  const [keyboardAction, setKeyboardAction] = useState(true);
  //handle portrait / landscape mode
  if (isMobile && window.DeviceOrientationEvent) {
    window.addEventListener('orientationchange', function () {
      if (!(JSON.parse(localStorage.getItem('videoActive')))) {
        location.reload();
      }
    }, false);
  }
  //preload carousel iamges and load to invisible div
  useEffect(() => {
    let getParentReference = document.getElementById("fwc-ctr-" + props.carosuselSpecs.carouselOccurence);
    // window.addEventListener("resize", handleResize, false);

    //preload carousel iamges and load to invisible div
    let imgDiv = (getParentReference.querySelector("#loadImg") != null) ? getParentReference.querySelector("#loadImg") : "";
    if (isMobile) {
      let imgDiv = getParentReference.querySelector("#loadImg");
      let tmp = imgDiv.innerHTML;
      for (var i = 0; i < carouselProps.length; i++) {
        // tmp = tmp + '<img src = ' + carouselProps[i].path + ' /> '
        tmp = tmp + '<img src = ' + carouselProps[i].path + ' /> '
        imgDiv.innerHTML = tmp;
      }
    }
    // Hide or show the carousel component based on the devices
    let showCarousel = props.carosuselSpecs.carouselDisplay;
    switch (true) {
      //hide in both
      case (showCarousel == "none"): {
        getParentReference.classList.add("hidden")
        break;
      }
      // hide in desktop and show only in mobile
      case (!isMobileOnly && showCarousel == "mobile-only"): {
        getParentReference.classList.add("hidden")
        break;
      }
      // hide in mobile and show in desktop
      case (isMobileOnly && showCarousel == "desktop-only"): {
        getParentReference.classList.add("hidden")
        break;
      }
      default: {
        getParentReference.classList.remove("hidden")
      }
    }

    // height of the carousel component
    const carsouelHeight = css`height:calc(550px * ${parseInt(props.carosuselSpecs.carouselHeight)}/100)`
    const carouselImageList = getParentReference.querySelector(".carousel-inner");
    if (props.carosuselSpecs.carouselHeight != "100%") carouselImageList.classList.add(carsouelHeight);
    var getVideoElements = getParentReference.querySelectorAll(".video-player");
    for (var videoFile = 0; videoFile < getVideoElements.length; videoFile++) {
      // to pause the video when the video tile is not visible to user
      getVideoElements[videoFile].pause();
    }

    // if only one item is present --- it should be static and hide the arrows, pagination dots and timer to null
    if (carouselProps.length < 2) {
      setArrowControl(false);
      setDotIndicator(false);
      setLoopingTimer(null);
      setKeyboardAction(false);
    }
    // else {
    const getArrows = getParentReference.querySelectorAll("a[class^='carousel-control-']");
    const getPaginationIndicators = getParentReference.querySelectorAll(".carousel-indicators li");
    const getActivePaginationDot = getParentReference.querySelector(".carousel-indicators .active");
    const getCopyContainer = getParentReference.querySelectorAll(".copy-placeholder");
    const getCopyCaption = getParentReference.querySelectorAll(".copy-caption");
    const getCTAElements = getParentReference.querySelectorAll(".carousel-cta-container");
    const getCopyDiv = getParentReference.querySelectorAll(".carousel-copy");
    let alignCopyLeft = (ipadPortrait) ? css`width:67% !important` : css`right:25%;width:62% !important;`
    let alignCopyCenter = (ipadPortrait) ? css`width:100% !important;text-align:center;position:relative;left:0;` : css`width:100% !important;text-align:center;margin:0 auto`//css`margin:0 auto;`
    let alignCopyRight = ((window.innerWidth <= 1536)) ? (!isMobile) ? css`width:62% !important;clear:both;float:right;position:relative;left:5%` : css`clear:both;float:right;position:relative;left:5%` : css`clear:both;float:right;`//css`left:50% !important;position:relative;`
    let alignCTARight = ((window.innerWidth <= 1536)) ? (!isMobile) ? css`clear:both;float:right;position:relative;left:5%` : css`clear:both;float:right;position:relative;left:5%` : css`clear:both;float:right;`//css`left:50% !important;position:relative;`
    let alignCTACenter = ((window.innerWidth == 1366)) ? css`margin-left:0;text-align:center` : css`margin-left:12px;text-align:center`//css`position:relative;text-align:right;left:5%;`
    let alignCopyTop = css`top:5% !important;bottom:unset !important;`
    let alignCopyBottom = css`top:unset !important;bottom:30%;`

    for (let slideCount = 0; slideCount < carouselProps.length; slideCount++) {

      /*Analytics fix - add id attribute to the elements dynamically - as the carousel plugin generates the DOM --- start */
      getParentReference.querySelector(".carousel").setAttribute("id", "carousel-outer");
      getParentReference.querySelector(".carousel-inner").setAttribute("id", "carousel_inner");
      //id for carousel-item 
      for (var cnt = 0; cnt < getParentReference.querySelectorAll(".carousel-item").length; cnt++) {
        (getParentReference.querySelectorAll(".carousel-item")[cnt].getAttribute("id") === null) ? getParentReference.querySelectorAll(".carousel-item")[cnt].setAttribute("id", "carousel_item_" + cnt) : '';
      }
      //id for carousel arrows
      for (var cnt = 0; cnt < getArrows.length; cnt++) {
        (getArrows[cnt].childNodes[0].classList.contains("carousel-control-prev-icon")) ? (getArrows[cnt].setAttribute("id", "carousel_arrow_prev"), getArrows[cnt].setAttribute("title", "Previous")) : (getArrows[cnt].setAttribute("id", "carousel_arrow_next"), getArrows[cnt].setAttribute("title", "Next"))
      }
      //id for carousel indicators
      for (var cnt = 0; cnt < getPaginationIndicators.length; cnt++) {
        getPaginationIndicators[cnt].setAttribute("id", "carousel_indicator_dot_" + cnt);
        getPaginationIndicators[cnt].setAttribute("title", "Frame " + (cnt + 1));
      }
      //id for CTA buttons/links
      for (var cnt = 0; cnt < getCTAElements.length; cnt++) {
        for (var childCnt = 0; childCnt < getCTAElements[cnt].childNodes.length; childCnt++) {
          if (getCTAElements[cnt].childNodes[childCnt].childNodes[childCnt] != undefined) getCTAElements[cnt].childNodes[childCnt].childNodes[childCnt].setAttribute("id", "carousel_cta_" + cnt + "_" + childCnt);
        }
      }

      /*Analytics fix - add id attribute to the elements dynamically - as the carousel plugin generates the DOM --- end */


      // path is to check if any image has been added---
      if (carouselProps[slideCount].path.length > 3) {
        var customiseArrows = css`
          font-size: 4rem;
          font-weight:100;
          background-image:none !important;
          text-decoration:none;
          position:absolute;
          top:35%;
        `
        // Arrows related --- start ------customise the default arrows to our requirement
        for (var cnt = 0; cnt < getArrows.length; cnt++) {
          (getArrows[cnt].childNodes[0].classList.contains("carousel-control-prev-icon")) ? getArrows[cnt].childNodes[0].innerHTML = "‹" : getArrows[cnt].childNodes[0].innerHTML = "›";
          getArrows[cnt].childNodes[0].classList.add(customiseArrows);
        }
        switch (true) {
          case (activeSlide == slideCount): {
            for (var cnt = 0; cnt < getArrows.length; cnt++) {
              getArrows[cnt].childNodes[0].style.color = carouselProps[activeSlide].arrowColor;
            }
            break;
          }
          default: {
            break;
          }
        }
        // Arrows related --- end ------

        // Pagination dots related --- start ------customise the default Pagination dots to our requirement
        getPaginationIndicators[slideCount].style.background = carouselProps[slideCount].PaginationDotColor;
        getActivePaginationDot.style.background = carouselProps[activeSlide].PaginationDotActiveColor;
        // Pagination dots related --- end ------




        //changes for higher resolutions
        if (getCopyContainer[slideCount] != undefined) {
          let setCopyPlaceHolderTop;
          switch (true) {
            case (window.innerWidth >= 1900 && window.innerWidth < 2303): {
              setCopyPlaceHolderTop = "15%"
              break;
            }
            case (window.innerWidth >= 2048 && window.innerWidth < 2304): {
              setCopyPlaceHolderTop = "35%"
              break;
            }
            case (window.innerWidth == 2304 && window.innerWidth < 3071): {
              setCopyPlaceHolderTop = "40%"
              break;
            }
            case (window.innerWidth >= 3072 && window.innerWidth < 4607): {
              setCopyPlaceHolderTop = "45%"
              break;
            }
            case (window.innerWidth >= 4608): {
              setCopyPlaceHolderTop = "50%"
              break;
            }
            default: {
              // getCopyContainer[slideCount].classList.add(alignCopyLeft);
            }
          }
          var addTopForCopyHolder = css`top:${setCopyPlaceHolderTop};`
          getCopyContainer[slideCount].classList.add(addTopForCopyHolder);
        }



        // Alignment of copy --- start ------align the copy as per  our requirement
        if (getCopyContainer[slideCount] != undefined) {
          switch (true) {
            case (carouselProps[slideCount].copyAlignment == "left"): {
              getCopyDiv[slideCount].classList.add(alignCopyLeft);
              getCopyContainer[slideCount].style.cssText = (window.innerWidth == 1366) ? "left:-7%" : "";
              break;
            }
            case (carouselProps[slideCount].copyAlignment == "center"): {
              getCopyDiv[slideCount].classList.add(alignCopyCenter);

              if (ipadPortrait) getCopyDiv[slideCount].parentNode.style.width = "100%"
              getCopyContainer[slideCount].style.cssText = (!ipadPortrait) ? (window.innerWidth == 1366) ? "left:48px !important;margin-top:0px;" : "margin-top:20px;left:0;" : "margin-top:-12px;left:0;";
              if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add(alignCTACenter);
              break;
            }
            case (carouselProps[slideCount].copyAlignment == "right"): {
              getCopyDiv[slideCount].classList.add(alignCopyRight);
              if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add(alignCTARight);
              getCopyContainer[slideCount].style.cssText = (window.innerWidth == 1366) ? "left:3%" : "";
              break;
            }
            case (carouselProps[slideCount].copyAlignment == "top"): {
              getCopyContainer[slideCount].parentNode.classList.add(alignCopyTop);
              if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add("text-center");
              break;
            }
            case (carouselProps[slideCount].copyAlignment == "bottom"): {
              getCopyContainer[slideCount].parentNode.classList.add(alignCopyBottom);
              if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add("text-center");
              break;
            }
            default: {
              getCopyContainer[slideCount].classList.add(alignCopyLeft);
            }
          }
        }
        // Alignment of copy --- end ------

        //CTA button styles
        if (carouselProps[slideCount].cta != undefined) {
          var ctaOneBorderBasedOnType = (carouselProps[slideCount].cta[0] != undefined && carouselProps[slideCount].cta[0].ctaType === 'link') ?
            "0 !important" : "1px solid " + carouselProps[slideCount].CtaOneBorderColor;
          var ctaTwoBorderBasedOnType = (carouselProps[slideCount].cta[1] != undefined && carouselProps[slideCount].cta[1].ctaType === 'link') ?
            "0 !important" : "1px solid " + carouselProps[slideCount].CtaOneBorderColor;
          var firstCTAStyle = css`
            color:${carouselProps[slideCount].CtaOneFontColor};
            border:${ctaOneBorderBasedOnType};
            background: ${carouselProps[slideCount].CtaOneBgColor};
            `
          var secondCTAStyle = css`
            color:${carouselProps[slideCount].CtaTwoFontColor};
            border:${ctaTwoBorderBasedOnType};
            background: ${carouselProps[slideCount].CtaTwoBgColor};
            `
          getCTAElements[slideCount].childNodes[0].childNodes[0].classList.add(firstCTAStyle);
          if (carouselProps[slideCount].CtaOneFontColor != "") getCTAElements[slideCount].childNodes[0].childNodes[0].style.cssText = "color:" + carouselProps[slideCount].CtaOneFontColor;
          if (!isMobile) {
            // for the hover effect of the CTA buttons - as only  min 1 and max 2 CTAs will be there at any time, the hover is handled by taking hex value from opencms
            getCTAElements[slideCount].childNodes[0].childNodes[0].addEventListener('mouseover', function (e) {
              var setBGOnHover = "";
              setBGOnHover = "background:" + carouselProps[slideCount].CtaOneHoverColor + ";color:" + carouselProps[slideCount].CtaOneFontHoverColor + ";";
              (getCTAElements[slideCount].childNodes[0].childNodes[0].classList.contains("btn-link")) ? setBGOnHover += "border:none !important" : setBGOnHover += "border : 1px solid " + carouselProps[slideCount].CtaOneBorderHoverColor;
              getCTAElements[slideCount].childNodes[0].childNodes[0].style.cssText = setBGOnHover;

            });
            getCTAElements[slideCount].childNodes[0].childNodes[0].addEventListener('mouseout', function () {
              var setBGOnMouseout = "";
              setBGOnMouseout = "background:" + carouselProps[slideCount].CtaOneBgColor + ";color:" + carouselProps[slideCount].CtaOneFontColor + ";";
              (getCTAElements[slideCount].childNodes[0].childNodes[0].classList.contains("btn-link")) ? setBGOnMouseout += "border:none !important" : setBGOnMouseout += "border : 1px solid " + carouselProps[slideCount].CtaOneBorderColor;
              getCTAElements[slideCount].childNodes[0].childNodes[0].style.cssText = setBGOnMouseout;
            });
          }
          if (getCTAElements[slideCount].childNodes[1] != undefined) {
            getCTAElements[slideCount].childNodes[1].childNodes[0].classList.add(secondCTAStyle);
            if (carouselProps[slideCount].CtaTwoFontColor != "") getCTAElements[slideCount].childNodes[1].childNodes[0].style.cssText = "color:" + carouselProps[slideCount].CtaTwoFontColor;
            if (!isMobile) {
              getCTAElements[slideCount].childNodes[1].childNodes[0].addEventListener('mouseover', function () {
                var setBGOnHover = "";
                setBGOnHover = "background:" + carouselProps[slideCount].CtaTwoHoverColor + ";color:" + carouselProps[slideCount].CtaTwoFontHoverColor + ";";
                (getCTAElements[slideCount].childNodes[1].childNodes[0].classList.contains("btn-link")) ? setBGOnHover += "border:none !important" : setBGOnHover += "border : 1px solid " + carouselProps[slideCount].CtaTwoBorderHoverColor;
                getCTAElements[slideCount].childNodes[1].childNodes[0].style.cssText = setBGOnHover;
              });
              getCTAElements[slideCount].childNodes[1].childNodes[0].addEventListener('mouseout', function () {
                var setBGOnMouseout = "";
                setBGOnMouseout = "background:" + carouselProps[slideCount].CtaTwoBgColor + ";color:" + carouselProps[slideCount].CtaTwoFontColor + ";";
                (getCTAElements[slideCount].childNodes[1].childNodes[0].classList.contains("btn-link")) ? setBGOnMouseout += "border:none !important" : setBGOnMouseout += "border : 1px solid " + carouselProps[slideCount].CtaTwoBorderColor;
                getCTAElements[slideCount].childNodes[1].childNodes[0].style.cssText = setBGOnMouseout;
              });
            }
          }
        }
      }

      // EIR-462 --- Fixes for 30%, 40%,50% --- start
      let getCarouselHeightFromProps = parseInt(props.carosuselSpecs.carouselHeight);
      switch (true) {
        //hide in both
        case (getCarouselHeightFromProps == 30): {
          getCopyContainer[slideCount].classList.add("thirty-percent")
          if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add("thirty-percent")
          break;
        }
        // hide in desktop and show only in mobile
        case (getCarouselHeightFromProps == 40): {
          getCopyContainer[slideCount].classList.add("forty-percent")
          if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add("forty-percent")
          break;
        }
        // hide in mobile and show in desktop
        case (getCarouselHeightFromProps == 50): {
          getCopyContainer[slideCount].classList.add("fifty-percent")
          if (getCTAElements[slideCount] != undefined) getCTAElements[slideCount].classList.add("fifty-percent")
          break;
        }
        default: {
          //
        }
      }

      // EIR-462 --- Fixes for 30%, 40%,50% --- end


    } // end of slideCount for loop

    // Countdown timer style ---- start -----
    //set the timer styles - as this is not mandatory for each tile, this has to be handled in a separate loop
    let timerControl = getParentReference.querySelectorAll(".carousel-countdown-timer");
    for (let timerCount = 0; timerCount < timerControl.length; timerCount++) {
      let setTimerPosition, setTimerCaptionPosition = "";
      var getSlideNumber = timerControl[timerCount].getAttribute("id").split("_")[1];
      var setRightForTimer = (window.innerWidth <= 1536) ? '-5%' : '0'; //for 1536 res and low, to align  the timer when selected Right in opencms
      if (carouselProps[getSlideNumber].timerAlignment === "right") {
        timerControl[timerCount].style.cssText = (window.outerWidth <= 1536) ? (ipadPortrait) ? "position:absolute;top:25%;left:70%;width:40%;" : (window.innerWidth == 1366 && !isMobile) ? "position:absolute;top:25%;left:65%;width:40%;" : "position:absolute;top:25%;left:65%;width:42%;" : "position:absolute;top:25%;left:62%;width:42%;"
      } else if (carouselProps[getSlideNumber].copyAlignment && carouselProps[getSlideNumber].timerAlignment === "center") {
        setTimerCaptionPosition = (ipadPortrait) ? "margin:0 auto" : (!isMobileOnly) ? "left:0;right:none;position:relative;margin:5px auto 0 auto;width:100%;padding-bottom:0.4rem" : "left:0%;right:none;position:relative;margin:5px 0 0px 5px;width:100%;";
        setTimerPosition = (ipadPortrait) ? "margin:0 auto" : (!isMobileOnly) ? "left:0;right:none;position:relative;margin:5px auto 0 auto;" : "left:28%;right:none;position:absolute;margin:10px 0 0px 5px";
        timerControl[timerCount].querySelector(".timer-caption").classList.add("text-center");
      } else if (carouselProps[getSlideNumber].copyAlignment && carouselProps[getSlideNumber].timerAlignment === "alignWithCopy") {
        setTimerCaptionPosition = (!higherModelIphone) ? "margin:5px 0;position:relative;" : "position:relative;width:100%;";
        setTimerPosition = (isMobileOnly) ? "margin:0 auto;postiion:relative;" : "margin: 15px 0 20px 0; position: relative; ";
        if (carouselProps[getSlideNumber].copyAlignment === "left") {
          setTimerCaptionPosition = (!higherModelIphone) ? "margin:5px 0;position:relative;text-align:left;width:55%" : "position:relative;width:100%;";
          timerControl[timerCount].style.cssText = "position:relative;width:50%"
        }
        if (carouselProps[getSlideNumber].copyAlignment === "right") {
          setTimerCaptionPosition = (!higherModelIphone) ? (window.innerWidth <= 1536) ? "width:62%;text-align:right;" : "width:55%;text-align:right;" : "position:relative;width:100%;";
          timerControl[timerCount].style.cssText = "position:relative;left:64%;clear:both;margin-bottom:10px;width:65%"
        }
      } else if (carouselProps[getSlideNumber].copyAlignment && carouselProps[getSlideNumber].timerAlignment === "left") {
        // setTimerCaptionPosition = "width:85%;";
        setTimerPosition = (ipadPortrait) ? "margin:10px 0 20px 0;position:absolute;top:15%;" : "";
        timerControl[timerCount].style.cssText = (ipadPortrait) ? "height: auto; width: 36%; position: absolute; min-height: 100px; left:0;top:15%;" : "height: auto; width: 42%; position: absolute; min-height: 100px; left:0;top:50%;"
      }
      var setTimerStyle = setTimerPosition + ";background:" + carouselProps[getSlideNumber].timerBGColor + ";color:" + carouselProps[getSlideNumber].timerFontColor;
      //***** Below null check will see if the timer is expired - if not then it applies the style *****/
      if (timerControl[timerCount].querySelector('.countdown-timer') != null) {
        timerControl[timerCount].querySelector('.countdown-timer').style.cssText = setTimerStyle;
        timerControl[timerCount].querySelector('.timer-caption').style.cssText = setTimerCaptionPosition;
        let getTimerLabels = timerControl[timerCount].querySelectorAll(".eir-countdown-text");
        //to set the font color for the labels in the timer -- effect less as dom refreshes
        for (let timerLabelCnt = 0; timerLabelCnt < getTimerLabels.length; timerLabelCnt++) {
          if (getTimerLabels[timerLabelCnt].tagName === "DIV") {
            var setTimerLabelColor = css`color:$carouselProps[getSlideNumber].timerLabelColor`;
            getTimerLabels[timerLabelCnt].style.cssText = 'color:' + carouselProps[getSlideNumber].timerLabelColor + ' !important'
          }
        }
      } else {
        timerControl[timerCount].style.cssText = "display: none !important";
      }
    } // end of timerCount for loop
    // Countdown timer style ---- end -----


    if (isMobile) {
      getParentReference.querySelector(".carousel-control-next").removeAttribute("href");
      getParentReference.querySelector(".carousel-control-prev").removeAttribute("href");
      // console.log("carouselProps.lengt >>>> ", carouselProps.length + "\nbottom >>> ", menuElementBottom);
      if (carouselProps.length > 1 && menuElementBottom > window.innerHeight) {
        //   console.log("bottom condition exceeds height");
        setElementIsClicked(false);
        window.clearTimeout(loopForCarouselMobile);
      }
      if (menuElement != null) {
        menuElement.addEventListener("click", function (e) {
          if (carouselProps.length > 1 && menuElementBottom > window.innerHeight) {
            //     console.log("top condition inside");
            // console.log("setElementIsClicked >>>> ", elementIsClicked + "\nbottom >>> ", menuElementBottom);
            setElementIsClicked(false);
          }
        }, true)
      }

      getParentReference.querySelector(".carousel-control-next").addEventListener("click", function (e) {
        //    console.log("click 1 -- next clicked");
        e.preventDefault();
        e.stopPropagation();
        setElementIsClicked(true);
        //   window.clearTimeout(loopForCarouselMobile);
      }, true)
      // getParentReference.querySelector(".carousel-control-next").addEventListener("touchstart", function (e) {
      //   window.clearTimeout(loopForCarouselMobile);
      // }, true)
      // getParentReference.querySelector(".carousel-control-next").addEventListener("touchend", function (e) {
      //   window.clearTimeout(loopForCarouselMobile);
      // }, true)
      getParentReference.querySelector(".carousel-control-prev").addEventListener("click", function (e) {
        //     console.log("click 2 -- prev clicked");
        e.preventDefault();
        e.stopPropagation();
        setElementIsClicked(true);
        //window.clearTimeout(loopForCarouselMobile);
      }, true)
      // getParentReference.querySelector(".carousel-control-prev").addEventListener("touchstart", function (e) {
      //   window.clearTimeout(loopForCarouselMobile);
      // }, true)
      // getParentReference.querySelector(".carousel-control-prev").addEventListener("touchend", function (e) {
      //   window.clearTimeout(loopForCarouselMobile);
      // }, true)
      if (elementIsClicked && carouselProps.length > 1 && menuElementBottom < window.innerHeight) {
        loopForCarouselMobile = setTimeout(() => (window.clearTimeout(loopForCarouselMobile), getParentReference.querySelector(".carousel-control-next").click()), (props.carosuselSpecs.MobileLoopInterval));
      } else {
        // console.log("cleartimeout");

      }
    }

  }, [activeSlide, elementIsClicked, menuElementBottom]);
  return (
    <div className="fullwidth-carousel-container" id={"fwc-ctr-" + props.carosuselSpecs.carouselOccurence}>
      < Carousel activeIndex={activeSlide} onSelect={handleSelect} controls={arrowControl} indicators={dotIndicator} interval={(parseInt(loopingTimer) === 0) ? null : parseInt(loopingTimer)} keyboard={keyboardAction}>
        {/* <Carousel activeIndex={activeSlide} onSelect={handleSelect} controls={arrowControl} indicators={dotIndicator} interval={null} keyboard={keyboardAction}> */}
        {carouselProps.map((item, i) =>
          <Carousel.Item className={(item.assetType == "video") ? "video-asset" : ''}>
            {
              item.assetType == "image" &&
              <div className="carousel-tile">
                <img

                  className="d-block w-100 carousel-tile-image"
                  src={item.path} alt={item.alt}
                />
                <Carousel.Caption className="container">
                  <div className="copy-placeholder"><div className="carousel-copy" dangerouslySetInnerHTML={renderContent(item.copy)}></div>
                    {item.timerTitle != undefined &&
                      <div className="carousel-countdown-timer" id={"timer_" + i} >
                        <h5 className="timer-caption">{item.timerTitle}</h5>
                        <CountdownTimer className="carousel-timer-container" date={item.timerDateTime} />
                      </div>
                    }
                    {item.cta != undefined &&
                      <div className="carousel-cta-container">
                        {item.cta.map((ctaprop, i) =>
                          <EirButton
                            key={i}
                            color="primary"
                            outline={true}
                            type={ctaprop.ctaType}
                            text={ctaprop.ctaText}
                            // name={ctaprop.ctaText}
                            // value={ctaprop.ctaText}
                            className="eir-text-secondary"
                            link={ctaprop.ctaLink}
                            videoModal={ctaprop.videoModal}
                            id = {i === 0 ? "fullwidth-carousel-arrange-call-back" : "fullwidth-carousel-call-us"}
                            title={ctaprop.ctaTitle}>{ctaprop.ctaText}</EirButton>
                        )}
                      </div>
                    }
                  </div>
                </Carousel.Caption>
              </div>
            }
            {
              item.assetType == "video" &&
              <video controls className="video-player">
                <source src={item.path} type="video/mp4" />
              </video>
            }
          </Carousel.Item>
        )
        }
      </Carousel>
      <div id="loadImg"></div>
    </div >
  );
}
export default EirFullWidthCarousel;